module.exports = __webpack_public_path__ + "static/media/clearFilter.628cc6c0.svg";